import { __awaiter } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useAemConfig } from '@as-react/common-components';
import { HTTPStatusCode } from '@as-react/common-types';
import CustomerApi from '../../api/customer/CustomerApi';
import { AccountVouchers } from '../../components/account/account-vouchers/AccountVouchers';
const AccountVouchersContainer = ({ title }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const [shouldRender, setShouldRender] = useState(false);
    const [vouchers, setVouchers] = useState([]);
    const fetchVouchers = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const answer = yield CustomerApi.getVouchers(servicesEndpoint, defaultRequestParams);
            if (answer.status !== HTTPStatusCode.NoContent) {
                setVouchers(answer.data);
            }
            setShouldRender(true);
        }
        catch (_a) { }
    });
    useEffect(() => {
        fetchVouchers();
    }, []);
    return shouldRender ? _jsx(AccountVouchers, { vouchers: vouchers, title: title }) : null;
};
export default AccountVouchersContainer;
